//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Type of authentication service used to authenticate user */
export const AuthenticationServiceType = {
    /** An internal authentication service (i.e. Database, Active Directory) */
    Internal: 0,

    /** An external authentication service (i.e. Facebook, Twitter, Google, etc.) */
    External: 1
} as const;

/** Type of authentication service used to authenticate user */
export const AuthenticationServiceTypeDescription: Record<number, string> = {
    0: "Internal",

    1: "External"
};

/** Type of authentication service used to authenticate user */
export type AuthenticationServiceType = typeof AuthenticationServiceType[keyof typeof AuthenticationServiceType];
